import { type Message, type MessageRole, type PreviousSessionMessageItem } from '@chatbot/typings/types';
import { dayjsObject } from '@shared/helpers/date-time';

/**
 * Parse API message format and convert to Message type
 * @param item - The message item from the API
 * @returns Parsed message in the application format
 */
export const parseApiMessage = (item: PreviousSessionMessageItem): Message => {
    // Determine role from message type
    let role: MessageRole = 'assistant'; // Default value
    if (item.message.type === 'human') {
        role = 'user';
    } else if (item.message.type === 'ai') {
        role = 'assistant';
    } else if (item.message.type === 'system') {
        role = 'system';
    }

    return {
        id: item.id.toString(),
        conversationId: item.session_id,
        role,
        content: item.message.content,

        // Convert UTC datetime from database to local time using dayjs
        createdAt: dayjsObject(item.created_at)
            .toDate(),
    };
};

/**
 * Parse array of API messages
 * @param items - Array of message items from the API
 * @returns Array of parsed messages sorted by timestamp in ascending order
 */
export const parseApiMessages = (items: PreviousSessionMessageItem[]): Message[] => {
    const parsedMessages = items.map(parseApiMessage);

    // Sort messages by timestamp (createdAt) in ascending order (oldest first, newest last)
    return parsedMessages.sort((messageA, messageB) => messageA.createdAt.getTime() - messageB.createdAt.getTime());
};
